export default function AboutPanel() {
    return (
        <div className="content-section">
            <p>A web app for simulating a waving flag.</p>
            <hr />
            <p>To learn more about FlagWaver,<br /> <a href="https://github.com/krikienoid/flagwaver" target="_blank" rel="noopener">view the project on GitHub</a>.</p>
        </div>
    );
}
